import request from '@/plugin/axios'
import util from "@/libs/util.js";
export function getUserPermissionInfo () {
  return request({
    url: '/api/admin/user/v2/front/info',
    method: 'get'
  })
}
export function getUserId () {
  return request({
    url: '/api/admin/user/front/info',
    method: 'get',
    params:{
      token:util.cookies.get("token")
    }
  })
}
